import React from 'react'

import clsx from 'clsx'

import Tag from 'components/Tag'
import { useEventContext } from 'context/EventContext'
import { ROUTE_NAMES } from 'routes'
import routeService from 'services/routes'

import classes from './TopicTag.module.scss'

const TopicTag = ({ topic }) => {
  const eventContent = useEventContext({ engagementComponent: 'topic-tag' })
  return (
    <div className={clsx('TopicTag', classes.root)}>
      <Tag
        {...eventContent.addEvent({
          engagementDetails: 'list-item_topic-name',
          engagementDestination: 'go-to_topic',
        })}
        href={routeService.generatePath(ROUTE_NAMES.RESOURCES_TOPIC, { slug: topic.slug })}
      >
        {topic.name}
      </Tag>
      {topic.linkedFrom && <span className={classes.count}>{topic.linkedFrom.posts.total}</span>}
    </div>
  )
}

export default TopicTag
